import React from 'react'
import classes from './FilterTextField.scss'

import Paper, { PaperProps } from '@mui/material/Paper'
import TextField, { TextFieldProps } from '@mui/material/TextField'

type FilterTextFieldProps = TextFieldProps & {
  icon?: JSX.Element,
  PaperProps?: PaperProps
}

const FilterTextField: React.FC<FilterTextFieldProps> = function ({
  icon,
  PaperProps,
  ...textField
}) {
  return (
    <Paper
      data-item
      classes={{ root: classes.paper }}
      {...PaperProps}
    >
      {icon}

      <TextField
        fullWidth
        slotProps={{
          input: textField.variant === 'outlined'
            ? textField.slotProps?.input
            : { disableUnderline: true, ...textField.slotProps?.input }
        }}
        variant="standard"
        {...textField}
      />
    </Paper>
  )
}

export default FilterTextField
